import React, { useState, useEffect } from 'react';
import './styles.css';  // Import the CSS file from the same directory

function ReverseSibCalculator() {
  const [ndauReceived, setNdauReceived] = useState('');
  const [sib, setSib] = useState('');
  const [ndauSent, setNdauSent] = useState('');

  useEffect(() => {
    const fetchSibValue = async () => {
      try {
        const response = await fetch('https://mainnet-3.ndau.tech:3030/price/current');
        const data = await response.json();
        if (data.sib) {
          const formattedSib = (data.sib / 10000000000).toFixed(2);
          setSib(formattedSib);
        }
      } catch (error) {
        console.error('Failed to fetch SIB:', error);
      }
    };
    fetchSibValue();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const E = parseFloat(sib) / 100;
    const calculatedNdauSent = parseFloat(ndauReceived.replace(/,/g, '')) * (E + 1);
    setNdauSent(calculatedNdauSent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
  };

  return (
    <div className="calculator">
      <h1>Reverse SIB Calculator</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="ndau_received">NDAU Received:</label>
          <input
            type="text"
            id="ndau_received"
            value={ndauReceived}
            onChange={e => setNdauReceived(e.target.value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','))}
            required
          />
        </div>
        <div>
          <label htmlFor="sib">Current SIB %:</label>
          <input
            type="text"
            id="sib"
            value={sib}
            onChange={e => setSib(e.target.value)}
            required
          />
        </div>
        <button type="submit">Calculate</button>
      </form>
      {ndauSent && <div className="data-item"><span>Result:</span> <span className="value">{ndauSent}</span></div>}
    </div>
  );
}

export default ReverseSibCalculator;
